
export default {
  name: 'LayoutError',

  layout: 'default',
}
